import React, { Component } from 'react';
import {connect} from 'react-redux'
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../common/back-link/index';
import PageTitle from '../../common/page-title';
import Divider from '../../common/divider';
import { getOutletRewardAllocations } from '../../../actions/outlet-reward-allocations';
import OutletDetails from './outlet-details';
import IncentiveDetails from './incentive-details';
import RewardAllocations from './reward-allocations';

class OutletRewardAllocationView extends Component {
  componentWillMount() {
    this.props.dispatch(getOutletRewardAllocations(this.props.match.params.incentives_outlets_id));
  }

  render() {
    const { dispatch, loading, outletRewardAllocations: { outlet, incentive, outletRewardAllocations } } = this.props;

    if (loading) {
      return <p>Loading...</p>;
    }

    return (
      <div className="fluid">
        <div className="container-fluid">
          <Row>
            <Col md={12}>

              <BackLink href={`/admin/outlets/${outlet.id}/view`}/>

              <PageTitle>OUTLET REWARD ALLOCATIONS</PageTitle>

              <Divider />

              <div className="mg-top-20">
                <OutletDetails outlet={outlet} />
              </div>

              <div className="mg-top-20">
                <IncentiveDetails incentive={incentive} />
              </div>

              <h3>REWARD ALLOCATIONS</h3>

              <RewardAllocations
                incentiveId={incentive.id}
                customerNumber={outlet.customer_number}
                outletRewardAllocations={outletRewardAllocations}
                incentivesOutletsId={this.props.match.params.incentives_outlets_id}
                dispatch={dispatch}
              />
            </Col>
          </Row>
        </div>
      </div>
    )
  }    
}

function mapStateToProps(state) {
    return {
      outletRewardAllocations: state.outletRewardAllocations,
      loading: state.outletRewardAllocations.fetching && !state.outletRewardAllocations.fetched,
      errors: state.outletRewardAllocations.errors,
    };
  }
  
  export default connect(mapStateToProps)(OutletRewardAllocationView);
  


// WEBPACK FOOTER //
// ./src/components/admin/outlet-reward-allocation-view/index.jsx